"use client"

import { Suspense } from "react"
import { AppShell } from "@/app/_components/chrome/app-shell"
import { ProductModalHost } from "@/app/_components/modals/product-modal-host"
import { ProductProviders } from "@/app/_components/providers/product-providers"

export default function AppLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <ProductProviders>
      <AppShell>{children}</AppShell>
      <Suspense fallback={null}>
        <ProductModalHost />
      </Suspense>
    </ProductProviders>
  )
}
